import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import styles from '@/common/components/LightDataGrid/LightDataGrid.styles';

const LightDataGridEmptyState = ({ text }) => (
  <Box sx={styles.emptyState}>
    <Typography variant="body1" color="text.tertiary">
      {text}
    </Typography>
  </Box>
);

const LightDataGrid = ({ emptyText, sx, slots, ...props }) => {
  const resolvedSlots = slots?.noRowsOverlay
    ? slots
    : {
        ...slots,
        ...(emptyText
          ? {
              noRowsOverlay: () => <LightDataGridEmptyState text={emptyText} />,
            }
          : {}),
      };

  return (
    <DataGrid
      autoHeight
      hideFooter
      disableColumnMenu
      disableRowSelectionOnClick
      disableColumnSorting
      sx={[styles.root, sx]}
      slots={resolvedSlots}
      {...props}
    />
  );
};

export default LightDataGrid;
